import './easing';
import './slick';
import './simple-dd';
import mapStyle from './map-style.json';
import twire from './twire';


'use strict';


export default function lynxCore() {

	// Cache
	var $window			= $(window);
	var $document 		= $(document);
	var $htmlBody 		= $('html, body');
	var $body 			= $('body');
	var $header 		= $('header');
	var $main 			= $('main');
	var $footer 		= $('footer');
	var $mobileMenu 	= $('div.mobile-menu');

	// TWire
	twire.init();

	// Re-initialize Alpine on the new content
	if (window.Alpine) {

        // This tells Alpine to look for new x-data components in the new HTML
        window.Alpine.initTree(document.querySelector('#swup')); 

    }

	// Add span to buttons for effect
	$('a.button, form.button').each(function() {

		$(this).wrapInner('<span class="text"></span>');

	});

	// Drop down
	$('span.drop-down').simpleDD({

		dropdownElement: 'span.child',
		noScriptLink:    '> a',
		event: 			'click'

	}).find('span.child a')
	  .end()
	  .find('span.child')
	  .on('click', 'a', function(e) { // Add to <a></a> to work with Alpine

		e.preventDefault();

		var $this = $(this);

		$this.closest('span.drop-down')
		     .find('input[type="hidden"]')
			 .val($this.data('value'));

		$this.closest('span.drop-down')
		     .find('> a')
			 .text($this.text());

		$htmlBody.trigger('click');

	});


	// Sticky header change
	$window.on('scroll.lynx', function() {

	    if ($window.scrollTop() > 100) {

	        $header.addClass('active');

	    } else {

	        $header.removeClass('active');

	    }

	});


	// Site messages
	$('div.site-message').each(function() {

		var $this = $(this);

		var icon = 'check-circle';

		if ($this.hasClass('warning') === true) {

			var icon = 'exclamation-circle';

		} else if ($this.hasClass('notice') === true) {

			var icon = 'info-circle';

		} else if ($this.hasClass('error') === true) {

			var icon = 'emoji-frown';

		}

		$this.append('<a class="bi bi-x close"></a>')
		     .prepend('<span class="bi bi-' + twire.util.html(icon) + '"></span> ')
		     .find('a.close')
			 .on('click', function(e) {

			$(this).closest('div.site-message')
			       .remove();

		});
		
		if ($this.hasClass('unclosable') === true) {
			
			$this.find('a.close').remove();
			
		}

	});


	// Drop down menu
	$header.find('div.menu a')
	       .on('click', function(e) {

		e.preventDefault();

		$header.addClass('drop-down-open');

	});

	$header.find('a.close')
	       .on('click', function(e) {

		e.preventDefault();

		$header.removeClass('drop-down-open');

	});



	// Menu highlight
	$header.find('a[href="' + $.escapeSelector(window.location.pathname) + '"]').addClass('active');

	// Scroll links
	$('a[data-scroll-to]').on('click', function(e) {

		e.preventDefault();
		
		$htmlBody.animate({

			scrollTop: $($(this).data('scroll-to')).offset().top - $header.height()

		}, 1000, 'easeInOutExpo');

	}).addClass('active');

	// Slick
	$('div[data-slick]').slick();

	// External links  
	$('a[href^="http://"], a[href^="https://"]').each(function() {

		$(this).attr('target', '_blank');

	});


	// View more
	$main.find('div.view-more a').each(function() {

		var $btn 		= $(this);
		var $parent 	= $btn.closest('div.view-more-parent');
		var $items 	= $parent.find('div.data div.item');

		if ($items.length <= 4) {

			// Remove the link if 4 or fewer items
			$btn.remove();

		} else {

			// Hide all items after the first 4
			$items.slice(4).hide();

			// Click handler to show all and remove button
			$btn.on('click', function(e) {

			e.preventDefault();
			$items.show();
			$(this).remove();

		});

		}

	});


	// Map
	$('body.book-now main div.map').each(function() {
		
		var $map = $(this);
		
		var location = new google.maps.LatLng($map.data('lat'), $map.data('lng'));

		var map = new google.maps.Map($map[0], {

			center: location,
			zoom: 12,
			scrollwheel: false,
			styles: mapStyle,
			zoomControl: true

		});
		
		// Marker
		var marker = new google.maps.Marker({

			map: map,
			position: location,
			icon: {

				url: '/assets/img/gui/icon-map-marker.svg',
				scaledSize: new google.maps.Size(41.71, 56.55)

			}

		});
		
		// Add click handlers
		/*google.maps.event.addListener(marker, 'click', function() {

			window.location.href = $map.data('href')

		});*/

	});


	// Booking radio
	$('body.book-now main section.payment a.link').on('click', function(e) {

		e.preventDefault();

		var $this 		= $(this);
		var $parent 	= $this.closest('div.links');
		var $section	= $this.closest('section.payment');

		$parent.find('a.link')
			   .removeClass('active');

		$this.addClass('active');

		$parent.find('input[type="hidden"]')
			   .val($this.data('method'));

		$section.find('div.payment-method-details')
		        .children('div')
				.hide()
				.filter('.' + $this.data('method'))
				.show();

		if ($parent.find('input[type="hidden"]').val() == 'card') {
			
			$section.find('div.card-details')
			        .show();

		} else {

			$section.find('div.card-details')
			        .hide();

		}

	});

	$('body.book-now').each(function() {

		require('./lynx-payment');

	});


	// Vimeo aspect ratio
	const vimeoVideos = document.querySelectorAll('iframe[data-vimeo-aspect-ratio]');

	vimeoVideos.forEach(video => {

	    const ratioParts = video.getAttribute('data-vimeo-aspect-ratio').split(':');

	    const w = parseInt(ratioParts[0]);
	    const h = parseInt(ratioParts[1]);

	    if (!isNaN(w) && !isNaN(h)) {

	        // Calculate percentages
	        const heightVW = (h / w) * 100;
	        const minWidthVH = (w / h) * 100;

	        // Inject the styles
	        video.style.height = heightVW + 'vw';
	        video.style.minWidth = minWidthVH + 'vh';
			
	    }

	});


};